import {
  RISK_CONTROL_CASES,
  RISK_CONTROL_CASES_REQUEST_PARAMS,
  RISK_CONTROL_FILTERS_KEY
} from "./control-constants";

export const customLocalStorage = {
  setFilters: function setFilters(value: any) {
    localStorage.setItem(RISK_CONTROL_FILTERS_KEY, JSON.stringify(value));
  },
  getFilters: function getFilters(): any {
    let storedFiltersParsed = {};
    try {
      const storedFiltersRaw = localStorage.getItem(RISK_CONTROL_FILTERS_KEY);
      storedFiltersParsed = storedFiltersRaw
        ? JSON.parse(storedFiltersRaw)
        : {};
    } catch (e) {
      console.error("Custom: error parsing stored filter sections", e);
    }
    return storedFiltersParsed;
  },
  updateFilter: function (keyValue: any) {
    const value = {
      ...this.getFilters(),
      ...keyValue
    };
    this.setFilters(value);
  },
  clearFilters: function clearFilters(): void {
    this.setFilters(null);
  },
  setRequestParams: function setRequestParams(value: any) {
    localStorage.setItem(
      RISK_CONTROL_CASES_REQUEST_PARAMS,
      JSON.stringify(value)
    );
  },
  getRequestParams: function getRequestParams(): any {
    let storedRequestParamsParsed = {};
    try {
      const storedRequestParamsRaw = localStorage.getItem(
        RISK_CONTROL_CASES_REQUEST_PARAMS
      );
      storedRequestParamsParsed = storedRequestParamsRaw
        ? JSON.parse(storedRequestParamsRaw)
        : {};
    } catch (e) {
      console.error("Custom: error parsing stored filter sections", e);
    }
    return storedRequestParamsParsed;
  },
  updateRequestParams: function (keyValue: any) {
    const value = {
      ...this.getRequestParams(),
      ...keyValue
    };
    this.setRequestParams(value);
  },
  clearRequestParams: function clearRequestParams(): void {
    this.setRequestParams(null);
  },

  setCases: function setCases(value: any) {
    localStorage.setItem(RISK_CONTROL_CASES, JSON.stringify(value));
  },
  getCases: function getCases(): any {
    let storedCasesParsed = {};
    try {
      const storedCasesRaw = localStorage.getItem(RISK_CONTROL_CASES);
      storedCasesParsed = storedCasesRaw ? JSON.parse(storedCasesRaw) : {};
    } catch (e) {
      console.error("Custom: error parsing stored filter sections", e);
    }
    return storedCasesParsed;
  },
  updateCases: function (keyValue: any) {
    const value = {
      ...this.getCases(),
      ...keyValue
    };
    this.setCases(value);
  },
  clearCases: function clearCases(): void {
    this.setCases(null);
  }
};
